<template>
  <el-dialog title="选择客户" :visible.sync="dialogVisible" width="520px"
    :close-on-click-modal="false" append-to-body>
    <div class="customer-search">
      <el-input v-model="keyword" placeholder="请输入客户ID，多个客户ID支持空格隔开"
        @keyup.enter.native="search" />
      <el-button type="primary" :loading="searching" @click="search">搜索</el-button>
    </div>
    <el-table :data="selectedCustomers" border max-height="300px" empty-text="暂无已选客户">
      <el-table-column prop="id" label="已选客户ID" align="center" />
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="delete-button" @click="remove(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CustomerSelector',
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      searching: false,
      selectedCustomers: []
    }
  },
  methods: {
    // 每次打开都复制传入 ID，取消弹窗不会污染调用方的数据。
    open(userIds) {
      this.selectedCustomers = userIds.map(id => ({ id: Number(id) }))
      this.keyword = ''
      this.dialogVisible = true
    },
    // 支持用空格一次查询多个客户，并过滤重复和不存在的 ID。
    search() {
      const ids = this.keyword.split(/\s+/).filter(Boolean)
      if (!ids.length || ids.some(id => !/^\d+$/.test(id))) {
        this.$message.warning('请输入正确的客户ID，多个ID使用空格隔开')
        return
      }
      const uniqueIds = Array.from(new Set(ids.map(Number)))
      this.searching = true
      Promise.all(uniqueIds.map(id => this.$api.clienteleApi.clientList({ id }))).then(results => {
        const foundIds = []
        results.forEach(res => {
          const list = res.data && res.data.data ? res.data.data : []
          list.forEach(item => foundIds.push(Number(item.id)))
        })
        const missingIds = uniqueIds.filter(id => foundIds.indexOf(id) === -1)
        if (missingIds.length) this.$message.warning(`客户ID不存在：${missingIds.join('、')}`)

        const selectedIds = this.selectedCustomers.map(item => item.id)
        foundIds.forEach(id => {
          if (selectedIds.indexOf(id) === -1) this.selectedCustomers.push({ id })
        })
        this.keyword = ''
      }).finally(() => {
        this.searching = false
      })
    },
    remove(index) {
      this.selectedCustomers.splice(index, 1)
    },
    confirm() {
      this.$emit('confirm', this.selectedCustomers.map(item => item.id))
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-search {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.delete-button {
  color: #f56c6c;
}
</style>
